import React from 'react';
import { connect } from 'react-redux';

import { Create } from 'components/detail';
import { SimpleFormNoInit } from 'components/form';
import { TextInput, BooleanInput, NumberInput, SelectInput, DateInput } from 'components/input';
import { crudGetList as crudGetListAction } from 'actions/dataActions';

import { minValue } from "components/form/validate";

import * as urls from './urls';
import * as utils from './utils';


export function getPaymentTypeChoices(payment_types) {
  const display_name_map = Object.keys(payment_types).reduce((result, payment_type_id) => {
    const display_name = payment_types[payment_type_id].display
    if (!result[display_name]) {
      result[display_name] = 0
    }
    result[display_name] += 1
    return result
  }, {})
  return [
    { id: 0, name: 'All'},
    ...Object.keys(payment_types).map((payment_type_id) => {
      const display_name = payment_types[payment_type_id].display
      return ({
        id: parseInt(payment_type_id, 10),
        name: display_name_map[display_name] > 1 ? `${payment_types[payment_type_id].name} - ${display_name}` : display_name,
      })
    })
  ];
}


const PromotionCreateBase = (props) => {
  const { formValues, payment_types } = props;
  const show_quota = formValues.quota_type === utils.QUOTA_TYPE_LIMITED;
  const payment_type_choices = getPaymentTypeChoices(payment_types)

  return (
    <Create 
      createBackendPath={urls.promotionBackendPath} 
      {...props}
    >
      <SimpleFormNoInit>
        <TextInput 
          source='name' 
          label='Name' 
          isRequired={true}
        />
        <DateInput 
          source='start' 
          label='Start Date' 
          isRequired={true}
        />
        <DateInput 
          source='end'
          label='End Date'
          isRequired={true}
        />
        <SelectInput 
          choices={utils.QUOTA_TYPE_CHOICES}
          source='quota_type'
          label='Quota Type'
          isRequired={true}
          defaultValue={utils.QUOTA_TYPE_UNLIMITED}
        />
        { show_quota 
          ? <NumberInput 
              source='quota' 
              label='Quota' 
              isRequired={true} 
              validators={[minValue(1)]} 
            />
          : null
        }
        <SelectInput
          source='payment_type_id'
          label='Payment Type'
          choices={payment_type_choices}
          isRequired={true}
          defaultValue={'0'}
        />
        <BooleanInput 
          source='is_active' 
          label="Status" 
          isRequired={true} 
          defaultValue={true}
        />
      </SimpleFormNoInit>
    </Create>
  );
};

export const PromotionCreate = connect(
  (state) => {
    const form_record = (state.form['record-form'] || {});
    return {
      formValues: form_record.values || {},
      payment_types: state.admin[utils.PaymentTypeResourceName].data,
    }
  }, (dispatch) => {
    return {
      customFetch: () => {
        dispatch(crudGetListAction(
          utils.PaymentTypeResourceName,
          urls.paymentTypeBackendPath,
          {},
          false
        ));
      },
    };
  }
)(PromotionCreateBase);



// WEBPACK FOOTER //
// ./src/routes/product/PromotionCreate.js